import type { Academy, AcademyCustomPage } from '~/generated_types';
import type { PageObject } from '../CustomPageCard/CustomPageCard.model';
import { Heading, Stack } from '@workramp/ui';
import AcademyThemeContent from '~/components/academies/common/academy-theme-content';
import withAcademyTheme from '~/components/academies/common/with-academy-theme';
import AcademyThemeCardWrapper from '~/components/academies/common/academy-theme-card-wrapper';
import AcademyNoContent from '~/components/academies/learner/academy-no-content';
import { CustomPageCard } from '../CustomPageCard/CustomPageCard';

interface AcademyLearnerCustomPageProps {
  academy: Academy['MINIMUM_THEME_CONTENT'];
  customPage: AcademyCustomPage['LEARNER_DETAIL'] | null;
  accessibleContentIds: string[];
  noContentMessage: string;
}

const AcademyLearnerCustomPageInner = (props: AcademyLearnerCustomPageProps) => {
  const { academy, customPage, accessibleContentIds, noContentMessage } = props;
  if (!customPage || !customPage.pageSections.length) {
    return (
      <AcademyThemeContent>
        <AcademyNoContent msg={noContentMessage} />
      </AcademyThemeContent>
    );
  }

  return (
    <AcademyThemeContent>
      {customPage.pageSections.map((section) => (
        <Stack size={6} key={section.id}>
          <Heading as="h2" level="md">
            {section.title}
          </Heading>
          <AcademyThemeCardWrapper>
            {section.pageObjects.map((object) => (
              <CustomPageCard
                key={object.id}
                pageObject={object as PageObject}
                academy={academy}
                accessibleContentIds={accessibleContentIds || []}
                pageSlug={customPage.slug}
              />
            ))}
          </AcademyThemeCardWrapper>
        </Stack>
      ))}
    </AcademyThemeContent>
  );
};

export const AcademyLearnerCustomPage = withAcademyTheme(AcademyLearnerCustomPageInner);
